function passwordStrength(e){

    // use the predefined laguage tags here
    let strengthLabels = {
        low:'',//Weak
        medium:'',//Medium
        high:''//High
    };

    // get the input value
    var value = e.target.value;

    // get the meter selector
    var meterSelector = e.target.dataset.strengthMeter;
    
    // define the regex expressions for strength determination
    //var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    var strongRegex = new RegExp("^(?=([^a-z]*[a-z]){1,})(?=([^A-Z]*[A-Z]){1,})(?=([^0-9]*[0-9]){1,})[A-Za-z\\d$@$#!%*?&.]{8,}$");
    var mediumRegex = new RegExp("^(?=([^a-z]*[a-z]){1,})(?=([^A-Z]*[A-Z]){1,})(?=([^0-9]*[0-9]){1,})[A-Za-z\\d$@$#!%*?&.]{8,}$");
    
    // set default value of strength
    var strengthClass = "low"

    // determine if it is strong or medium
    if(strongRegex.test(value)) {
        strengthClass = "high";
    } else if (mediumRegex.test(value)) {
        strengthClass = "medium";
    }

    // operate on targeted meter
    var meter = document.querySelector(meterSelector);
    meter.classList.remove('low');
    meter.classList.remove('medium');
    meter.classList.remove('high');
    meter.classList.add(strengthClass);

    meter.querySelector('.cmx-strength-meter__label').innerText = strengthLabels[strengthClass];
}